var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap__site",attrs:{"id":"app"}},[(_vm.hideNav)?_c('NavAside'):_vm._e(),_c('main',{staticClass:"wrapper"},[_c('router-view')],1),(_vm.loader)?_c('Loader'):_vm._e(),_c('AttentionMessage'),(_vm.smallScreen)?_c('MobileNotOptimizedMessage'):_vm._e(),_c('CookiesMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }